import { jsx as _jsx } from "react/jsx-runtime";
const X = () => (_jsx("svg", Object.assign({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M12.1962 1H14.5721L9.38269 6.92981L15.4875 15H10.7087L6.96298 10.1067L2.68221 15H0.302885L5.8524 8.65625L0 1H4.9L8.28221 5.4726L12.1962 1ZM11.3615 13.5798H12.6774L4.18317 2.34615H2.76971L11.3615 13.5798Z" }) })));
X.iconName = "x";
X.iconCategory = "Social";
export default X;
